export default __webpack_public_path__ + "static/media/Use case 2 .2f359229.svg";